import React from 'react'
import "../AboutMe/AboutMe.css"

import pro from "../AboutMe/pro.jpeg"

function AboutMe() {
  return (
    <div className="main1">
      <div className="heading">
        <h3> ABOUT ME</h3>
      </div>
      <div className="tot">
        <div className="left">
          <img
            src={pro}
            // height="75%" width="65%"
          />
        </div>
        <div className="right">
          A self-motivated undergraduate who is interested in programming and
          web development . Always excited to learn new technology and new
          things with positive thinking.Always believe the things to happen is
          bright way. Follows right path and good at listening and learning.
        </div>
      </div>
    </div>
  );
}

export default AboutMe